//
// TextMetadataField
//
// A text-input.

import { observer } from 'mobx-react-lite'

import { TextInput } from '../../components'

export const TextMetadataField = observer(function TextMetadataField(props) {
    const {
        className,
        field,
        fieldname,
        fieldpath,
        item,
        language,
        renderkey,
        multiline,
        onChange,
        ...other
    } = props

    let classes = 'cc-Field cc-Textfield cc-TextMetadataField ws-text'
    if (className) classes += ' ' + className

    const fieldvalue = field.is_localized ? field.value[language] : field.value

    let formattedfieldvalue =
        fieldvalue !== null && fieldvalue !== undefined ? fieldvalue.toString() : null

    const onChangeText = event => {
        const metadatafield = item.metadata.get(fieldpath)
        item.setMetadataField(
            fieldpath,
            metadatafield.type,
            metadatafield.is_localized,
            event.target.value,
            language
        )
    }
    const onBlurText = event => {
        const metadatafield = item.metadata.get(fieldpath)
        item.setMetadataField(
            fieldpath,
            metadatafield.type,
            metadatafield.is_localized,
            event.target.value.trim(),
            language
        )
        onChange && onChange(item)
    }

    const lang = field.is_localized ? { language: language } : {}
    const inputrenderkey = renderkey + (field.is_localized ? '.' + language : '')

    return (
        <div className={classes} {...other}>
            <TextInput
                multiline={multiline}
                enabled={true}
                value={formattedfieldvalue}
                {...lang}
                onChange={onChangeText}
                onBlur={onBlurText}
                renderkey={inputrenderkey}
            />
        </div>
    )
})
